import React, { forwardRef } from 'react';
import { Loader2 } from 'lucide-react';
import { cn } from '../../utils/cn';

const VARIANTS = {
  primary:   'bg-ink text-cream hover:bg-ink-2 border border-ink',
  secondary: 'bg-surface text-text hover:bg-bg-2 border border-border',
  ghost:     'bg-transparent text-text hover:bg-bg-2 border border-transparent',
  danger:    'bg-danger text-cream hover:bg-danger/90 border border-danger',
  outline:   'bg-transparent text-text hover:bg-bg-2 border border-ink',
};

const SIZES = {
  xs: 'w-6  h-6  rounded-sm [&_svg]:w-3.5 [&_svg]:h-3.5',
  sm: 'w-8  h-8  rounded-md [&_svg]:w-4   [&_svg]:h-4',
  md: 'w-9  h-9  rounded-md [&_svg]:w-[18px] [&_svg]:h-[18px]',
  lg: 'w-11 h-11 rounded-lg [&_svg]:w-5   [&_svg]:h-5',
};

export const IconButton = forwardRef(function IconButton(
  {
    as: Component = 'button',
    variant = 'ghost',
    size = 'md',
    icon,
    isLoading,
    isDisabled,
    'aria-label': ariaLabel,
    className,
    type,
    ...rest
  },
  ref
) {
  const isButton = Component === 'button';
  return (
    <Component
      ref={ref}
      type={isButton ? type || 'button' : undefined}
      aria-label={ariaLabel}
      disabled={isButton ? (isDisabled || isLoading) : undefined}
      aria-disabled={isDisabled || isLoading}
      className={cn(
        'inline-flex items-center justify-center transition-colors duration-fast outline-none',
        'focus-visible:ring-2 focus-visible:ring-ink focus-visible:ring-offset-2 focus-visible:ring-offset-bg',
        'disabled:opacity-50 disabled:pointer-events-none',
        SIZES[size],
        VARIANTS[variant],
        className,
      )}
      {...rest}
    >
      {isLoading ? <Loader2 className="animate-spin" strokeWidth={1.8} /> : icon}
    </Component>
  );
});

export default IconButton;
